<template>
  <div class="header-bar flex-row" >
    <ul class="left noWrap">
      <li @click="showModal('lang')" >{{lang.name}}<img src="/eosrent/images/lang-down-white.png" class="lang-icon" alt="">

        <div class="language-box" v-show="showLang" >
          <div class="lang-div" @click.stop="hideLangBox">
            <ul @mouseleave="hideLangBox">
              <li class="active" @click="changeLocale(lang.id)">{{lang.name}} <img src="/eosrent/images/lang-box-icon-green.png" class="lang-icon" alt=""></li>
              <li v-for="(item, index) in setLangArr"  :key="index"  @click="changeLocale(item.id)" >
                {{item.name}}
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li @click="showModal('order')">{{$t('index.header-title-order-search')}}</li>
      <li @click="showModal('rentExplain')">{{$t('index.header-title-rent-explain')}}</li>
    </ul>
    <div class="right" @click="goWalletIo">
    </div>

    <cpurentExplain v-if="showCpuExplainModal.showModal" :refs="showCpuExplainModal"></cpurentExplain>
    <orderSearchModal v-if="showOrderSearchModal.showModal" :refs="showOrderSearchModal"></orderSearchModal>

  </div>
</template>

<script>
import cpurentExplain from './cpu_rent_explain'
import mixins from '../mixin'
import orderSearchModal from './order_search'
import {Utils} from './../utils/patch'

export default {
  data () {
    return {
      showCpuExplainModal: {
        showModal: false,
        type: null
      },
      showOrderSearchModal: {
        showModal: false
      },
      showLang: false,
      lang: '',
      langArr: [
        {
          id: 'zh',
          name: '中文'
        },
        {
          id: 'en',
          name: 'English'
        },
        {
          id: 'ko',
          name: '한국어'
        }
      ],
      setLangArr: []
    }
  },
  mixins: [mixins],
  created () {
    if (this.$route.query.lang) {
      this.$i18n.locale = this.$route.query.lang;
      this.changeLocale(this.$i18n.locale);
      return
    }
    let lang = Utils.getLocal('lang');
    let systemLang = navigator.language.slice(0, 2);
    console.log(systemLang, navigator.language)
    lang ? this.changeLocale(lang) : this.changeLocale(systemLang);
  },
  components: {
    cpurentExplain,
    orderSearchModal
  },
  mounted () {
  },
  methods: {
    changeLocale (type) { // 切换语言
      this.$i18n.locale = type;
      let sourceData = new Set([...this.langArr]);
      let newLangSet = new Set();

      for (let elem of sourceData.values()) {
        newLangSet.add(elem);
      }
      for (let item of newLangSet.values()) {
        if (item.id === type) {
          this.lang = item;
          newLangSet.delete(item)
        }
      }
      this.setLangArr = Array.from(newLangSet);
      localStorage.setItem('lang', type);
      this.hideLangBox();
    },
    showModal (data) {
      if (data === 'rentExplain') {
        this.showCpuExplainModal.showModal = true;
        this.showCpuExplainModal.type = 'CPU_RENT';
      }
      if (data === 'order') {
        this.showOrderSearchModal.showModal = true;
      }
      if (data === 'lang') {
        this.showLang = true;
      }
    },
    hideLangBox () {
      this.showLang = false;
    },
    goWalletIo () {
      window.open(this.locationRoot(`?channel=${this.$route.query.channel ? encodeURIComponent(this.$route.query.channel) : encodeURIComponent('eosrent')}`), '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public-header.vue